import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pageNumber'
})
export class PageNumberPipe implements PipeTransform {

    constructor() {
    }

    transform(value: any[], pageNumber: number, pageSize: number): any[] {
        const result = [];
        for (let i = pageSize * pageNumber; i < pageSize * (pageNumber + 1); i++) {
            if (value.length > i) {
                result.push(value[i]);
            }
        }
        return result;
    }
}
